import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const Channel = Loadable(lazy(() => import('views/Channel')));
const ChannelHub = Loadable(lazy(() => import('views/ChannelHub')));
const Log = Loadable(lazy(() => import('views/Log')));
const Setting = Loadable(lazy(() => import('views/Setting')));
const Token = Loadable(lazy(() => import('views/Token')));
const Profile = Loadable(lazy(() => import('views/Profile')));
const NotFoundView = Loadable(lazy(() => import('views/Error')));

// dashboard routing
const Dashboard = Loadable(lazy(() => import('views/Dashboard')));
const ModelSquare = Loadable(lazy(() => import('views/ModelSquare')));
const SupplierConsole = Loadable(lazy(() => import('views/SupplierConsole')));
const Wallet = Loadable(lazy(() => import('views/Wallet')));
const Usage = Loadable(lazy(() => import('views/Usage')));
const Customer = Loadable(lazy(() => import('views/Customer')));
const OfflineTopup = Loadable(lazy(() => import('views/OfflineTopup')));
const UsageBoard = Loadable(lazy(() => import('views/UsageBoard')));
const Playground = Loadable(lazy(() => import('views/Playground')));
const Team = Loadable(lazy(() => import('views/Team')));
const UpstreamRecon = Loadable(lazy(() => import('views/UpstreamRecon')));
const VideoReconciliation = Loadable(lazy(() => import('views/VideoReconciliation')));
const ProductPricing = Loadable(lazy(() => import('views/ProductPricing')));
const Billing = Loadable(lazy(() => import('views/Billing')));
const UserSpend = Loadable(lazy(() => import('views/UserSpend')));
const RouteHealth = Loadable(lazy(() => import('views/RouteHealth')));
const SupplierKeys = Loadable(lazy(() => import('views/SupplierKeys')));
const V3CustomerPricing = Loadable(lazy(() => import('views/V3CustomerPricing')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/panel',
  element: <MainLayout />,
  children: [
    {
      path: '',
      element: <Dashboard />
    },
    {
      path: 'dashboard',
      element: <Dashboard />
    },
    {
      path: 'playground',
      element: <Playground />
    },
    {
      path: 'modelsquare',
      element: <ModelSquare />
    },
    {
      path: 'model-square',
      element: <ModelSquare />
    },
    {
      path: 'supplier',
      element: <ChannelHub />
    },
    {
      path: 'channel',
      element: <ChannelHub />
    },
    {
      path: 'log',
      element: <Log />
    },
    {
      path: 'usage',
      element: <Log />
    },
    {
      path: 'offlinetopup',
      element: <OfflineTopup />
    },
    {
      path: 'usageboard',
      element: <UsageBoard />
    },
    {
      path: 'setting',
      element: <Setting />
    },
    {
      path: 'token',
      element: <Token />
    },
    {
      path: 'wallet',
      element: <Wallet />
    },
    {
      path: 'customer',
      element: <Customer />
    },
    {
      path: 'customer-pricing',
      element: <V3CustomerPricing />
    },

    {
      path: 'profile',
      element: <Profile />
    },
    {
      path: 'team',
      element: <Team />
    },
    {
      path: 'pricing-catalog',
      element: <Navigate to="/panel/product-pricing" replace />
    },
    {
      path: 'pricing-discounts',
      element: <Navigate to="/panel/customer-pricing" replace />
    },
    {
      path: 'upstream-recon',
      element: <UpstreamRecon />
    },
    {
      path: 'video-reconciliation',
      element: <VideoReconciliation />
    },
    // The temporary scheme picker is retired. Preserve old bookmarks, but
    // always send them to the one production reconciliation workflow.
    {
      path: 'upstream-recon-demo',
      element: <Navigate to="/panel/upstream-recon" replace />
    },
    {
      path: 'sku-wizard',
      element: <Navigate to="/panel/product-pricing" replace />
    },

    {
      path: 'product-pricing',
      element: <ProductPricing />
    },
    {
      path: 'pricing',
      element: <Navigate to="/panel/product-pricing" replace />
    },
    {
      path: 'supply',
      element: <SupplierKeys />
    },
    {
      path: 'billing',
      element: <Billing />
    },
    {
      path: 'user-spend',
      element: <UserSpend />
    },
    {
      path: 'route-health',
      element: <RouteHealth />
    },
    {
      path: '404',
      element: <NotFoundView />
    }
  ]
};

export default MainRoutes;
